import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6">
            <h5>Joey Pandina Math Tutoring</h5>
            <p className="text-muted mb-4">
              Empowering students to excel in mathematics through personalized, 
              engaging, and effective tutoring services.
            </p>
            <Link to="/schedule" className="btn btn-outline-light">
              Book a Session
            </Link>
          </div>
          
          <div className="col-lg-2 col-md-6 col-6">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <Link className="text-decoration-none text-muted" to="/">Home</Link>
              </li>
              <li>
                <Link className="text-decoration-none text-muted" to="/about">About</Link>
              </li>
              <li>
                <Link className="text-decoration-none text-muted" to="/services">Services</Link>
              </li>
              <li>
                <Link className="text-decoration-none text-muted" to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
          
          <div className="col-lg-3 col-md-6 col-6">
            <h5>Services</h5>
            <ul className="list-unstyled">
              <li className="text-muted">Middle School Math</li>
              <li className="text-muted">High School Math</li>
              <li className="text-muted">Test Preparation</li>
              <li className="text-muted">Homework Help</li>
            </ul>
          </div>
          
          <div className="col-lg-3 col-md-6">
            <h5>Contact Information</h5>
            <ul className="list-unstyled text-muted">
              <li className="mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope me-2" viewBox="0 0 16 16">
                  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
                </svg>
                joey.pandina@example.com
              </li>
              <li className="mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone me-2" viewBox="0 0 16 16">
                  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                </svg>
                (123) 456-7890
              </li>
              <li className="mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar-check me-2" viewBox="0 0 16 16">
                  <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                </svg>
                <Link to="/schedule" className="text-decoration-none text-muted">
                  Schedule on Calendly
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <hr className="my-4 opacity-25" />
        
        <div className="row">
          <div className="col-md-6 mb-3 mb-md-0">
            <p className="mb-0 text-muted">
              &copy; {currentYear} Joey Pandina. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-md-end">
            <Link to="/privacy-policy" className="text-decoration-none text-muted me-3">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-decoration-none text-muted">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
